import { render, staticRenderFns } from "./LayoutPayBox.vue?vue&type=template&id=0bca5055&scoped=true&"
import script from "./LayoutPayBox.vue?vue&type=script&lang=js&"
export * from "./LayoutPayBox.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPayBox.vue?vue&type=style&index=0&id=0bca5055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca5055",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bca5055')) {
      api.createRecord('0bca5055', component.options)
    } else {
      api.reload('0bca5055', component.options)
    }
    module.hot.accept("./LayoutPayBox.vue?vue&type=template&id=0bca5055&scoped=true&", function () {
      api.rerender('0bca5055', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/pay-box/LayoutPayBox.vue"
export default component.exports